import { FilterOption } from '@/components/ui/FilterSelect/FilterSelect';

export enum FilterNames {
  CATEGORY = 'category',
  INTEGRATION = 'integration',
  STATUS = 'status',
  CUSTOMER = 'customer',
  OWNER = 'owner',
  MODELS = 'models',
  PROVIDERS = 'providers',
  APPS = 'apps',
}

export const CREDENTIALS_PAGE_FILTER_NAMES = [FilterNames.APPS];

export const AGENTS_PAGE_FILTER_NAMES = [FilterNames.CUSTOMER];

export const DASHBOARD_FILTER_NAMES = [FilterNames.MODELS, FilterNames.PROVIDERS, FilterNames.CUSTOMER];

export const mapFiltersToApiParams = (selectedFilters: FilterOption[], paramName: string) =>
  selectedFilters.length > 0 ? { [paramName]: selectedFilters.map(f => f.value) } : {};
